import { useMemo, useState } from 'react';

export default function useClientTable(records = [], getSearchText = (record) => Object.values(record || {}).join(' ')) {
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const matchingRecords = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return records;
    return records.filter((record) => String(getSearchText(record)).toLowerCase().includes(normalizedQuery));
  }, [records, getSearchText, query]);

  const totalRecords = matchingRecords.length;
  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));
  const currentPage = Math.min(page, totalPages);
  const visibleRecords = matchingRecords.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return {
    query,
    setQuery: (nextQuery) => { setQuery(nextQuery); setPage(1); },
    page: currentPage,
    setPage,
    pageSize,
    setPageSize: (size) => { setPageSize(size); setPage(1); },
    totalRecords,
    totalPages,
    visibleRecords,
  };
}
